module.exports = __webpack_public_path__ + "img/icon_chuangxin@2x.1b0da3c2.png";